import ContentGroupType from '@/lib/constants/challengeModel/ContentGroupType.enum';
import SectionContentGroupContext from './SectionContentGroupContext';
import SectionLeftContent from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemFields/Section/SectionLeftContent';
import SectionRightContent from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemFields/Section/SectionRightContent';
import React from 'react';

type SectionContentGroupProps = {
  which: ContentGroupType;
  children: React.ReactNode;
};

type SectionContentGroupComponentProps = {
  children: React.ReactNode;
};

const sectionContentGroupComponents = {
  [ContentGroupType.LEFT]: (props: SectionContentGroupComponentProps) => (
    <SectionLeftContent style={{ marginRight: 72 }} {...props} />
  ),
  [ContentGroupType.RIGHT]: (props: SectionContentGroupComponentProps) => (
    <SectionRightContent style={{ width: 360 }} {...props} />
  ),
  [ContentGroupType.BOTTOM]: 'footer',
};

const SectionContentGroup = ({ which, children }: SectionContentGroupProps) => {
  const SectionContentGroupComponent = sectionContentGroupComponents[which];

  return (
    <SectionContentGroupContext.Provider value={which}>
      <SectionContentGroupComponent>{children}</SectionContentGroupComponent>
    </SectionContentGroupContext.Provider>
  );
};

export default SectionContentGroup;
